(function () {
	"use strict";

	angular
		.module("app.search")
		.controller("SearchController", SearchController);

	SearchController.$inject = ["$scope", "$cookies", "SearchService"];

	function SearchController($scope, $cookies, SearchService) {
		/* jshint validthis:true */
		var vm = this;

		function activate() {
			vm.searchKey = null;
			vm.searchHistory = ($cookies.get('searchHistory') || '').split(',').filter(function (item) {
				return item != ''
			});
			SearchService.getLastViewProducts()
				.then(function (response) {
					vm.lastViewProducts = response;
				});
		}
		$scope.$watch("vm.searchKey", function (value) {
			if (value) {
				vm.addSearchHistory(value);
				SearchService.searchProduct(value)
					.then(function (response) {
						vm.searchProductResult = response;
					});

				SearchService.searchCategory(value)
					.then(function (response) {
						vm.searchCategoryResult = response;
					})
			}
		});

		vm.addSearchHistory = function (value) {
			vm.searchHistory.push(value);
			vm.searchHistory = vm.searchHistory.reverse().slice(0, 5)
			$cookies.put('searchHistory', vm.searchHistory);
		}

		vm.clearLastViewProduct = function () {
			$cookies.remove('LastViewProduct');
			vm.lastViewProducts = {};
		}

		vm.focus = function (templateId) {
			vm.focused = true;
			vm.mouseleaved = false;
			vm.showSearchResult = true;
			$('.arama .input-group').addClass('search-focused');
			if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				$("#" + templateId + " .arama").addClass('mobile-search-active');
			}
		}

		vm.blurSearch = function (templateId) {
			vm.focused = false;
			console.log('vm.blurSearch :>> ', vm.focused, vm.mouseleaved, !vm.focused && vm.mouseleaved);
			if (!vm.focused && vm.mouseleaved) {
				vm.clear(templateId);
			}
		}

		vm.mouseleaveSearch = function (templateId) {
			vm.mouseleaved = true;
			if (!vm.focused && vm.mouseleaved) {
				vm.clear(templateId);
			}
		}

		vm.clear = function (templateId) {
			vm.showSearchResult = false;
			vm.searchProductResult = null;
			vm.searchCategoryResult = null;
			vm.searchKey = null;
			$('.arama .input-group').removeClass('search-focused');
			$("#" + templateId + " .arama").removeClass('mobile-search-active');
		}

		vm.clearSearchHistory = function () {
			$cookies.remove('searchHistory');
			vm.searchHistory = [];
		}

		vm.setSearch = function (history) {
			vm.searchKey = history;
		}

		activate();
	}
})();